import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
`

export const Comment = styled.div`
  color: midnightBlue.main;
  margin-bottom: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
`

export const Description = styled.div`
  color: ${myPalette.mutedText.main};
  font-size: 14px;
  line-height: 14px;
`

export const Amount = styled.div`
  font-size: 18px;
  font-weight: 700;
  text-align: right;
`

export const Currency = styled.span`
  font-size: 16px;
  font-weight: 700;
  text-align: right;
`
